import Pagination from 'react-bootstrap/Pagination';

interface IPagingControlsProps {
  page: number;
  pageCount: number;
  maxPlusOrMinusPagesToShow?: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export const PagingControls = ({
  page,
  pageCount,
  maxPlusOrMinusPagesToShow = 5,
  onPageChange,
  className = ''
}: IPagingControlsProps) => {
  const prevPage = page > 1 ? page - 1 : page;
  const nextPage = page < pageCount ? page + 1 : page;
  const firstPageInRange = page - maxPlusOrMinusPagesToShow;
  const lastPageInRange = page + maxPlusOrMinusPagesToShow;
  const pageRange = [];

  //no need to show paging if only a single page
  if (pageCount <= 1) {
    return <></>;
  }

  if (firstPageInRange > 2) {
    // Add a separator
    pageRange.push({
      number: firstPageInRange - 1,
      label: 'ellipsis'
    });
  }

  for (let i = firstPageInRange; i <= lastPageInRange; i++) {
    // Don't want to add negative pages or pages past pageCount
    if (i < 1 || i > pageCount) {
      continue;
    }
    pageRange.push({
      label: i,
      number: i,
      active: i === page
    });
  }

  if (lastPageInRange < pageCount - 1) {
    // Add a separator
    pageRange.push({
      number: lastPageInRange + 1,
      label: 'ellipsis'
    });
  }

  //return paging controls
  return (
    <Pagination className={className ?? ''}>
      <Pagination.First onClick={() => onPageChange(1)} disabled={page <= 1} />
      <Pagination.Prev onClick={() => onPageChange(prevPage)} disabled={page <= 1} />
      {pageRange.map((pg, index) => {
        if (pg.label === 'ellipsis') {
          return <Pagination.Ellipsis key={index} onClick={() => onPageChange(pg.number)} />;
        } else {
          return (
            <Pagination.Item key={index} active={pg.active} onClick={() => onPageChange(pg.number)}>
              {pg.label}
            </Pagination.Item>
          );
        }
      })}
      <Pagination.Next onClick={() => onPageChange(nextPage)} disabled={page >= pageCount} />
      <Pagination.Last onClick={() => onPageChange(pageCount)} disabled={page >= pageCount} />
    </Pagination>
  );
};

export default PagingControls;
